<p-confirmPopup></p-confirmPopup>
<custom-table [config]="customTable">
</custom-table>

<section>
    <form [formGroup]="actividadesForm"(ngSubmit)="onSubmit()" >

        <p-dialog [(visible)]="displayModal" [modal]="true" 
            [autoZIndex]="true" [draggable]="false" [resizable]="true" [maximizable]="true" 
            [breakpoints]="{'640px': '100vw'}" [style]="{width: '80vw'}">

            <ng-template pTemplate="header">
				<CustomTitle [title]="formTitle" />
			</ng-template>

            <ng-template pTemplate="content">
                <main class="grid formgrid p-fluid">
                    <div class="field col-12 md:col-6">
                        <label class="ml-3" for="codificacion">{{trans.codificacion}}<span style="color: red">*</span></label>
                        <input pInputText formControlName="codificacion" id="codificacion" type="text" />
                        <ng-container *ngIf="actividadesForm.get('codificacion')?.invalid && actividadesForm.get('codificacion')?.touched">
                            <app-form-group-error-message [control]="actividadesForm.get('codificacion')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label class="ml-3" for="descripcion">{{trans.descripcion}}<span style="color: red">*</span></label>
                        <input pInputText formControlName="descripcion" id="descripcion" type="text"/>
                        <ng-container *ngIf="actividadesForm.get('descripcion')?.invalid && actividadesForm.get('descripcion')?.touched">
                            <app-form-group-error-message [control]="actividadesForm.get('descripcion')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-8">
                        <label class="ml-3" for="permisoId">{{trans.permiso}}<span style="color: red">*</span></label>
                        <p-dropdown [options]="permisos" formControlName="permisoId" appendTo="body" filter="true"
                            placeholder="Select" optionLabel="codificacion" optionValue="id" autoWidth="false" [style]="{'width':'100%'}">
                        </p-dropdown>
                        <ng-container *ngIf="actividadesForm.get('permisoId')?.invalid && actividadesForm.get('permisoId')?.dirty">
                            <app-form-group-error-message [control]="actividadesForm.get('permisoId')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 container-checkbox">
						<label for="manual" class="label-text block ml-3">{{trans.manual}}</label>
						<p-checkbox [binary]="true" formControlName="manual" inputId="binary"></p-checkbox>
					</div>
                </main>
            </ng-template>
            
            <ng-template pTemplate="footer">
                <div class="field col-12">
                    <div class="flex justify-content-between">
                        <button pButton type="button" [label]="'form.button.limpiar' | translate" iconPos="right" icon="pi pi-eraser" class="tax-app-button"
							style="width: 16rem;" (click)="resetForm()"></button>
						<button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save" iconPos="right" class="tax-app-button"
							style="width: 16rem;" [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
                    </div>
                </div>
            </ng-template>
        </p-dialog>

    </form>
</section>

<app-admin-actividades-historico></app-admin-actividades-historico>